import { makeStyles, createStyles, Theme } from '@material-ui/core/styles';
import sicrediColors from 'assets/styles/default.scss';

export default makeStyles(
  (theme: Theme) =>
    createStyles({
      root: {
        display: 'flex',
        flexDirection: 'column',
        width: '100%',
        height: 'calc(100vh - 52px)',
        justifyContent: 'center',
        alignItems: 'center',
        fontFamily: '"Exo 2", sans-serif',
        fontWeight: 700,
        lineHeight: '24px',
        textAlign: 'center',
      },
      icon: {
        color: sicrediColors.primarySicredi,
        width: 50,
        height: 50,
        margin: theme.spacing(2),
      },
      title: {
        fontSize: 26,
        margin: theme.spacing(0, 1, 1),
      },
      subtitle: {
        fontSize: 16,
        margin: theme.spacing(0, 1, 1),
      },
    }),
  { name: 'VotacaoAgenciaConcluida' }
);
